<div kendoTooltip
     filter=".menu-hook"
     [titleTemplate]="titleTemplate"
     [tooltipTemplate]="template"
     [showAfter]="0"
     position="top"
     [style.height.%]="heightPct">
    <ng-template #titleTemplate let-anchor>
        Dep Time: {{ anchor.nativeElement.getAttribute('data-service-dep-time')}}<br/>
        Arr Time: {{ anchor.nativeElement.getAttribute('data-service-arr-time')}}<br/>
        {{ anchor.nativeElement.getAttribute('data-metric-info')}}
    </ng-template>
    <ng-template #template let-anchor>
    </ng-template>
   <div #tubemap class="ra-tubemap-container"></div>
</div>
<kendo-contextmenu [target]="tubemap"
                   [items]="menuItems"
                   filter=".menu-hook"
                   showOn="click"
                   (select)="processMenuItemClick($event)"></kendo-contextmenu>
<kendo-contextmenu [target]="tubemap"
                   [items]="tubeMenuItems"
                   filter=".train-axis .tick"
                   showOn="click"
                   (popupOpen)="menuOpen($event)"
                   (select)="processMenuItemClick($event)"></kendo-contextmenu>